<template>
  <div class="page">
    <!-- 日期选择 start -->
    <div
      class="zhezhao"
      @click="onCancel"
    ></div>
    <div class="selbox">
      <p class="title">筛选</p>
      <p class="content">
        时间
      </p>

      <ul class="listtime">
        <mt-picker
          :slots="slots"
          @change="onDateChange"
          class="inner-picker"
          :visibleItemCount="3"
        ></mt-picker>
      </ul>

      <p class="content">
        销售
      </p>
      <div class="search">
        <mt-search
          v-model="searchName"
          :show="true"
        >
          <mt-cell
            v-for="item in searchData"
            :title="item.name"
            :key="item.id"
            :class="{'search-active':item.id == activeId}"
            @click.native="searchClick(item)"
          >
          </mt-cell>
        </mt-search>
      </div>
      <!-- <ul class="listtime">
        <mt-picker
          :slots="saleSlots"
          @change="onSaleChange"
          valueKey="name"
          class="inner-picker"
          :visibleItemCount="3"
        ></mt-picker>
      </ul> -->

      <p class="bottom-btn">
        <mt-button
          type="default"
          @click="onReset"
          class="reset"
          plain
        >重置</mt-button>
        <mt-button
          type="primary"
          @click="confirmFilter"
          class="confirm"
        >确定</mt-button>
      </p>

    </div>
    <!-- 日期选择 end -->
  </div>
</template>
<script>
import slotsList from '../../../assets/js/slotsList'
import dateChange from '../../../mixins/dateChange.js'
import { getCurrentMonth } from '../../../assets/js/date'
export default {
  mixins: [dateChange],
  props: {
    dateInfo: {
      type: Object,
      default: () => { }
    },
  },
  watch: {
    searchName(nval, oval) {
      this.onChange(nval)
    }
  },
  data() {
    return {
      searchValue: this.dateInfo.active.id,
      searchName: this.dateInfo.active.name,
      activeId: '',
      isFirst: true,
      searchData: this.dateInfo.nameData,
      isFilter: false,
      slots: null,
      date: {
        begin_time: '',
        end_time: '',
      },
      saleSlots: [],
    }

  },
  created() {
  },

  mounted() {
    this.slots = slotsList.Monthslots(this.dateInfo.begin_time, this.dateInfo.end_time)
  },
  methods: {
    onChange(val) {
      let temp = []
      if (this.isFirst) {
        this.searchData = this.dateInfo.nameData
        this.isFirst = false
        return false
      }
      const keys = Object.keys(this.dateInfo.nameData)
      for (let i = 0; i < keys.length; i++) {
        if (this.dateInfo.nameData[keys[i]]['name'].indexOf(val) >= 0) {
          temp.push(this.dateInfo.nameData[keys[i]])
        }
      }
      this.searchData = temp

    },
    searchClick(item) {
      this.activeId = item.id
      this.searchName = item.name
      this.searchValue = item.id
       this.onOk()
    },
    onSaleChange(picker, values) {
      this.c_sale = values[0]
    },
    onCancel() {
      this.$emit('cancel')
    },
    onReset() { 
        this.searchName = ''
        this.searchValue = ''
        this.date = getCurrentMonth()
        this.slots = slotsList.Monthslots(this.date.begin_time, this.date.end_time)
        this.onOk()
    },
    confirmFilter() {
      this.isFilter = false
      this.onOk()
    },
    onOk() {
        const info = {
        begin_time: this.c_begin_time == '0/0' ? this.dateInfo.begin_time : this.c_begin_time,
        end_time: this.c_end_time == '0/0' ? this.dateInfo.end_time : this.c_end_time,
        sale: {id:this.searchValue},
      }
      console.log('info',info)
      this.$emit('ok', info)
      this.$emit('cancel')
    }
  }
}
</script>
<style scoped>
.page {
  width: 100%;
  height: 100%;
}
.search {
  position: relative;
  width: 100%;
  height: 270px;
  overflow: auto;
  margin-top: 20px;
  z-index: 9999;
}
.search-active {
  color: #5483d2;
}
.bottom-btn {
  display: flex;
  height: 1.25rem;
  line-height: 1.25rem;
  position: absolute;
  width: 100%;
  bottom: 0;
  text-align: center;
}
.reset {
  width: 50%;
  height: 1.25rem;
  font-size: 16px;
  border-left: none;
  border-radius: 0;
}
.confirm {
  width: 50%;
  border-radius: 0;
  height: 1.25rem;
  font-size: 16px;
  background: #4083D8;
}
</style>
<style >
.search .mint-search {
  height: 270px;
  font-style: 12px;
  overflow: auto;
}
.search .mint-searchbar {
    position: relative;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    box-sizing: border-box;
    display: flex;
    padding: 4px 10px;
    z-index: 1;
    margin: 0 4px;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 4px;
}
.search .mint-cell-wrapper {
    font-size: 12px;
    color: #666;
}
</style>


// WEBPACK FOOTER //
// src/components/performance/components/date-right.vue